export default "__VITE_ASSET__C4OZzWi___"